module.exports = __webpack_public_path__ + "img/chicken-or-pork-dijon.fea8b62a.jpg";